import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bell, FileText, Plus, Settings as SettingsIcon, Home, Calendar, LogOut } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api` 
  : '/api';

export default function Layout({ children, onLogout }) {
  const location = useLocation();
  const [notificationCount, setNotificationCount] = React.useState(0);

  React.useEffect(() => {
    axios.get(`${API}/notifications?unread_only=true`)
      .then(res => setNotificationCount(res.data.length))
      .catch(() => {});
  }, [location]);

  const navItems = [
    { path: '/', label: 'الرئيسية', icon: Home },
    { path: '/add-case', label: 'قضية جديدة', icon: Plus },
    { path: '/hearings', label: 'الجلسات', icon: Calendar },
    { path: '/notifications', label: 'الإشعارات', icon: Bell, badge: notificationCount },
    { path: '/settings', label: 'الإعدادات', icon: SettingsIcon },
  ];

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-lg">
                <FileText className="w-6 h-6 text-white" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900">نظام متابعة القضايا</h1>
            </Link>
            
            <div className="flex items-center gap-2">
              <nav className="flex gap-1">
                {navItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.path;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      data-testid={`nav-${item.label}`}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors relative ${
                        isActive
                          ? 'bg-blue-50 text-blue-600 font-medium'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`}
                    >
                      <Icon className="w-5 h-5" />
                      <span className="hidden sm:inline">{item.label}</span>
                      {item.badge > 0 && (
                        <Badge variant="destructive" className="absolute -top-1 -right-1 h-5 min-w-5 flex items-center justify-center px-1 text-xs">
                          {item.badge}
                        </Badge>
                      )}
                    </Link>
                  );
                })}
              </nav>
              
              <div className="border-r border-gray-200 h-8 mx-2"></div>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={handleLogout}
                data-testid="logout-btn"
                className="text-red-600 hover:text-red-700 hover:bg-red-50"
              >
                <LogOut className="w-5 h-5 ml-1" />
                <span className="hidden sm:inline">خروج</span>
              </Button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}
